import { render, staticRenderFns } from "./learners.vue?vue&type=template&id=39ffb1b7&scoped=true"
import script from "./learners.ts?vue&type=script&lang=ts&external"
export * from "./learners.ts?vue&type=script&lang=ts&external"
import style0 from "./learners.scss?vue&type=style&index=0&id=39ffb1b7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ffb1b7",
  null
  
)

export default component.exports